<div [ngClass]="class" *ngIf="config && (config?.title || config?.content)" padding
    [ngStyle]="{'background-color': config.bgColor}" class="ion-padding padding">
    <div class="jumbotron-heading" *ngIf="config.title" [ngStyle]="{'color': config.titleTextColor }">
        {{config.title | multiLang}}
    </div>

    <div class="jumbotron-content" *ngIf="config.content" [ngStyle]="{'color': config.contentTextColor }">
        {{config.content | multiLang}}
    </div>
</div>